import React, { useEffect, useMemo, useState } from 'react';
import './App.css';
import Bio from './Content/BodyRegion/Bio/Bio';
import Publications from './Content/BodyRegion/Publications/Publications';
import Certs from './Content/BodyRegion/Certs/Certs';
import { SocialIcon } from 'react-social-icons';
import headshot from './Content/PhotoRegion/Photo/res/self.jpg';

function useHashRoute(defaultRoute) {
  const [route, setRoute] = useState(() => {
    const h = window.location.hash.replace('#/', '') || defaultRoute;
    return h;
  });
  useEffect(() => {
    const onHashChange = () => {
      const h = window.location.hash.replace('#/', '') || defaultRoute;
      setRoute(h);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [defaultRoute]);
  return [route, (r) => (window.location.hash = `#/${r}`)];
}

function NavBar({ route, navigate }) {
  const [open, setOpen] = useState(false);
  const tabs = [
    { key: 'bio', label: 'Bio' },
    { key: 'videos', label: 'Videos' },
    { key: 'publications', label: 'Publications' },
    { key: 'certs', label: 'Certifications' },
    { key: 'links', label: 'Links' },
  ];
  return (
    <header className="nav">
      <div className="brand">
        <span className="brand-text">whitaker.ai</span>
      </div>
      <button
        className="hamburger"
        aria-label="Menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="burger" />
      </button>
      <nav className={`tabs ${open ? 'open' : ''}`} aria-label="Primary">
        {tabs.map((t) => (
          <button
            key={t.key}
            className={`tab ${route === t.key ? 'active' : ''}`}
            onClick={() => {
              navigate(t.key);
              setOpen(false);
            }}
          >
            {t.label}
          </button>
        ))}
      </nav>
    </header>
  );
}

function Videos() {
  const videos = useMemo(
    () => [
      // Replace with your own video IDs
      'S6tDmH-pGD0',
      'wTfFu8jXlQ0',
      '8s30P1I2qsE',
    ],
    []
  );
  return (
    <section className="section">
      <div className="bio-header">
        <div className="bio-title">Videos</div>
      </div>
      <div className="video-grid">
        {videos.map((id) => (
          <div className="video" key={id}>
            <iframe
              title={`YouTube ${id}`}
              src={`https://www.youtube.com/embed/${id}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        ))}
      </div>
      <div className="links-row">
        <SocialIcon fgColor="#fff" bgColor="#0000" url="https://www.youtube.com/@justindwhitaker" target="_blank" />
      </div>
    </section>
  );
}

function Links() {
  return (
    <section className="section">
      <div className="bio-header">
        <div className="bio-title">Links</div>
      </div>
      <div className="links-row">
        <a className="link" href="https://www.linkedin.com/in/justin-d-whitaker" target="_blank" rel="noreferrer">
          <SocialIcon fgColor="#fff" bgColor="#0000" url="https://www.linkedin.com/in/justin-d-whitaker" />
          <span className="link-label">LinkedIn</span>
        </a>
        <a className="link" href="mailto:justindwhitaker@icloud.com" target="_blank" rel="noreferrer">
          <SocialIcon fgColor="#fff" bgColor="#0000" url="mailto:justindwhitaker@icloud.com" />
          <span className="link-label">Email</span>
        </a>
        <a className="link" href="https://www.youtube.com/@justindwhitaker" target="_blank" rel="noreferrer">
          <SocialIcon fgColor="#fff" bgColor="#0000" url="https://www.youtube.com/@justindwhitaker" />
          <span className="link-label">YouTube</span>
        </a>
        <a className="link" href="https://github.com/jdwhitaker" target="_blank" rel="noreferrer">
          <SocialIcon fgColor="#fff" bgColor="#0000" url="https://github.com/jdwhitaker" />
          <span className="link-label">GitHub</span>
        </a>
      </div>
    </section>
  );
}

function PageView({ route }) {
  // Simple fade-in on route change
  return (
    <main key={route} className="page fade-in">
      {route === 'bio' && (
        <section className="section bio-section">
          <div className="bio-header">
            <div className="bio-title">Securing AI at Scale</div>
            <div className="bio-kicker">Making LLMs trustworthy, resilient, and safe‑by‑default.</div>
          </div>
          <img className="bio-headshot" src={headshot} alt="Headshot" />
          <div className="bio-content">
            <Bio />
          </div>
        </section>
      )}
      {route === 'videos' && <Videos />}
      {route === 'publications' && (
        <section className="section">
          <div className="bio-header">
            <div className="bio-title">Publications</div>
          </div>
          <Publications />
        </section>
      )}
      {route === 'certs' && (
        <section className="section">
          <Certs />
        </section>
      )}
      {route === 'links' && <Links />}
    </main>
  );
}

export default function App() {
  const [route, navigate] = useHashRoute('bio');
  return (
    <div className="app">
      <NavBar route={route} navigate={navigate} />
      <PageView route={route} />
    </div>
  );
}
